module.exports = __webpack_public_path__ + "pic3.jpg?2c596c2eed632ae09117aeb379e243e4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/testimonials/pic3.jpg
// module id = 54
// module chunks = 13